import { render, staticRenderFns } from "./CalculateGiftPoints.vue?vue&type=template&id=b1740dd8&scoped=true"
import script from "./CalculateGiftPoints.vue?vue&type=script&lang=js"
export * from "./CalculateGiftPoints.vue?vue&type=script&lang=js"
import style0 from "./CalculateGiftPoints.vue?vue&type=style&index=0&id=b1740dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1740dd8",
  null
  
)

export default component.exports